import {Body} from '../../typography/body';

interface Props {
    value: string;
}

export function RowValue(props: Props) {
    return (
        <Body size='small' color='medium' maintainLineBreaks={true} wrapAnywhere={true}>
            {props.value}
        </Body>
    );
}
